import { Undefinable } from '@ps/utils';

interface CpiEditabilityContext {
  readonly hasTargetMargin: Undefinable<boolean>;
  readonly hasImpersonatedBuyer: boolean;
  readonly isOperator: boolean;
  readonly canOverrideCompany: Undefinable<boolean>;
}

export function isCpiEditable({
  hasTargetMargin,
  hasImpersonatedBuyer,
  isOperator,
  canOverrideCompany,
}: CpiEditabilityContext): boolean {
  if (hasTargetMargin && hasImpersonatedBuyer) {
    return false;
  }

  if (isOperator && !hasImpersonatedBuyer) {
    return true;
  }

  return !!canOverrideCompany;
}
